// extracted by mini-css-extract-plugin
export default {"searchWrapper":"ImportHeader_searchWrapper__JLXTa","searchButton":"ImportHeader_searchButton__eGJGs"};